<template>
    <div class="settings-costs">

        <!-- Título / Breadcrumbs / Botões -->
        <mu-row justify-content="center" align-items="center">
            <mu-col span="6" sm="6" md="6" lg="6" xl="6">

                <!-- Título da página -->
                <mu-title color="secondary" textStrong="700">Centro de Custo</mu-title>

                <!-- Breadcrumbs -->
                <mu-breadcrumbs divider="—">
                    <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
                    <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
                </mu-breadcrumbs>
            </mu-col>
            <mu-col span="6" sm="6" md="6" lg="6" xl="6">

                <!-- Menu Mobile -->
                <mu-menu cover placement="left-start" class="menu-mobile">
                    <mu-button icon>
                        <font-awesome-icon icon="ellipsis-v" class="icon-md"/>
                    </mu-button>
                    <mu-list slot="content">
                        <mu-list-item button @click="createCost">
                            <mu-list-item-title>Criar Centro de Custo</mu-list-item-title>
                            <mu-list-item-action><font-awesome-icon icon="plus" class="icon-md"/></mu-list-item-action>
                        </mu-list-item>
                    </mu-list>
                </mu-menu>

                <!-- Menu Desktop -->
                <mu-button class="menu-desktop" @click="createCost" round color="primary">
                    <font-awesome-icon icon="plus" class="icon-md icon-margin-left"/>
                    Criar Centro de Custo
                </mu-button>

            </mu-col>
        </mu-row>

        <!-- Formulário -->
        <mu-dialog :title="control.title" width="550" :open.sync="control.visible">
            <mu-text-field v-model="form.name" full-width help-text="* mínimo de 5 caracteres." label="Nome *"></mu-text-field>
            <mu-text-field v-model="form.description" full-width label="Descrição *"></mu-text-field>
            <mu-flex>
                <mu-button round color="primary" class="button-save" @click="saveForm()" :disabled="!form.name || form.name.length < 5 || !form.description">
                    <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                    Salvar
                </mu-button>
                <mu-button round @click="closeCost">Cancelar</mu-button>
            </mu-flex>

            <!-- Bloco para excluir o contato -->
            <mu-paper class="cancel" :z-depth="1" v-if="form.id">

                <!-- Pergunta para excluir o contato  -->
                <mu-row justify-content="center" align-items="center">
                    <mu-col span="12" sm="12" md="8" lg="8" xl="8">
                        <mu-flex class="title" justify-content="start" align-items="center">
                            <font-awesome-icon icon="exclamation-triangle" class="icon-lg icon-margin-left color-red"/>
                            <strong>Excluir Centro de Custo?</strong>
                        </mu-flex>
                    </mu-col>
                    <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                        <div class="text-right">
                            <mu-button round color="error" @click="handleDialogDelete(true)">
                                <font-awesome-icon icon="trash" class="icon-md icon-margin-left"/>
                                Excluir
                            </mu-button>
                        </div>
                    </mu-col>
                </mu-row>

                <!-- Dialogo para confirmar exclusão de campanha -->
                <mu-dialog title="Excluir a Centro de Custo" width="600" max-width="80%" :esc-press-close="false" :overlay-close="false" :open.sync="cancel.openDelete">
                    Tem certeza que deseja excluir a Centro de Custo <strong>{{ form.name }}</strong>
                    <mu-button slot="actions" round @click="handleDialogDelete(false)">Cancelar</mu-button>
                    <mu-button slot="actions" round color="error" @click="deleteForm()">
                        <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                        Confirmar
                    </mu-button>
                </mu-dialog>

            </mu-paper>

        </mu-dialog>

        <!-- Listagem de Centro de Custo -->
        <div class="costs" v-if="!cost.loading">
            <mu-paper :z-depth="1">

                <!-- Listagem dos cost tablet/desktop -->
                <mu-data-table :columns="cost.columns" :data="cost.list" @row-click="editCost" v-if="viewport !== 'mobile'" class="mu-table-custom">
                    <template slot="empty">
                        <div class="box-table-empty">
                            Não foi encontrado registros de Centro de Custo
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <td>{{ scope.row.id }}</td>
                        <td>{{ dateFormat(scope.row.created_at, true) }}</td>
                        <td>{{ scope.row.name }}</td>
                        <td>{{ scope.row.description }}</td>
                    </template>
                </mu-data-table>

                <!-- Listagem de cost mobile -->
                <mu-list textline="two-line" v-if="viewport === 'mobile'">
                    <span v-for="(item, key) in cost.list" :key="key" @click="editCost(null, item, null)">
                        <mu-list-item button>
                            <mu-list-item-content>
                                <mu-list-item-title>{{ item.name }}</mu-list-item-title>
                                <mu-list-item-sub-title>
                                    Código: {{ item.id }}<br>
                                    {{ item.description }}
                                </mu-list-item-sub-title>
                            </mu-list-item-content>
                            <mu-list-item-action>
                                <font-awesome-icon icon="pen" class="icon-md icon-margin-left"/>
                            </mu-list-item-action>
                        </mu-list-item>
                        <mu-divider></mu-divider>
                    </span>
                </mu-list>
            </mu-paper>

            <!-- Paginação -->
            <mu-flex class="paginate" justify-content="center" v-if="cost.paging.total > cost.paging.size">
                <mu-pagination :total="cost.paging.total" :page-count="5" :page-size="cost.paging.size" :current.sync="cost.paging.page" @change="load()"></mu-pagination>
            </mu-flex>
        </div>

        <!-- Loading -->
        <mu-loading text="Carregando a lista de palavras de Centro de Custo" v-if="cost.loading"></mu-loading>

    </div>
</template>

<script>
    import CostServices from '@/services/settings/costs'

    export default {
        name: 'app-settings-cost',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Configurações',
                        route: 'app.settings',
                        disabled: false
                    },
                    {
                        text: 'Centro de Custo',
                        disabled: true
                    }
                ],
                control: {
                    visible: false
                },
                form: {},
                cost: {
                    loading: false,
                    paging: {
                        page: 1,
                        size: 10,
                        total: 0
                    },
                    columns: [
                        { title: 'Código', name: 'id' },
                        { title: 'Data', name: 'created_at' },
                        { title: 'Nome', name: 'name' },
                        { title: 'Descrição', name: 'description' }
                    ],
                    list: []
                },
                cancel: {
                    openDelete: false
                }
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Carregamos os dados da listagem assim que o componente for criado
         */
        created () {
            this.load()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Carrega a listagem de custos passando como parametro a paginação
             */
            async load () {
                try {
                    this.cost.loading = true

                    let result = await CostServices.findAll({
                        page: this.cost.paging.page
                    })

                    if (result && result.status) {
                        this.cost.paging.page = result.currentPage
                        this.cost.paging.total = result.rowCount
                        this.cost.list = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.cost.loading = false
                }
            },

            /**
             * Método para habilitar a opção de criar um novo item para custos
             * ele habilita o componente dialog e atualiza algumas propriedades de títulos e outros
             */
            createCost () {
                this.control.type = 'create'
                this.control.visible = true
                this.control.title = 'Criar Centro de Custo'
                this.form = {}
            },

            /**
             * Método para habilitar a opção de editar um item para custos
             * ele habilita o componente dialog e atualiza algumas propriedades de títulos e outros
             */
            editCost (index, row, event) {
                this.control.type = 'edit'
                this.control.visible = true
                this.control.title = 'Editar Centro de Custo'
                this.form = row
            },

            /**
             * Método fecha o dialog que é utilizado para criar e editar
             * um item da custo
             */
            closeCost () {
                this.control.visible = false
            },

            /**
             * Método fecha o dialog que abre para excluir um determinado
             * item da custos
             */
            handleDialogDelete (value) {
                this.cancel.openDelete = value
            },

            /**
             * Método utilizado para salvar um custo, seja ela um
             * novo registro ou edição
             */
            async saveForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Salvando a Centro de Custo.')

                    let result

                    if (this.control.type === 'create') {
                        result = await CostServices.store(this.form)
                    } else {
                        result = await CostServices.update(this.form)
                    }

                    if (result && result.status) {
                        this.closeCost()
                        this.load()
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        return
                    } else if (result && result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível salvar os dados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Método utilizado para deletar um item do custo
             */
            async deleteForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde... Excluíndo a Centro de Custo.')

                    let result = await CostServices.destroy(this.form.id)

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.handleDialogDelete(false)
                        this.closeCost()
                        this.load()
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível deletar o registro.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Utilizado para verificar se o acesso é de desktop, table ou mobile
             */
            viewport () {
                return this.$currentViewport.label
            }
        }
    }
</script>

<style lang="stylus" scoped>

    .button-save
        margin-right 10px

    .settings-costs

        .menu-desktop
            float right

        .mu-list
                padding 0

        .costs
            margin 20px 0

            td
                cursor pointer

            .row
                margin 0 20px
                padding 15px 0

                .text-right
                    text-align right

            .paginate
                padding 20px

            .mu-paper
                padding 0px

        .mu-button-float-right
            float right
            margin-left 10px

    .cancel
        background lighten(#F44336, 92%)
        padding 20px
        color #999
        border 1px #F44336 dotted
        margin-top 20px

        .title
            i
                font-size 18px !important
                color #F44336
            strong
                font-size 16px
                padding-left 5px
                color #F44336

        .text-center
            text-align center

        .text-right
            text-align right

</style>
